<div class="layout-container-content">
    <ng-content></ng-content>
</div>
